import { IChainEntitlementsUpdateBody } from "../ApplicationsAbilitationsManagementStepFive/module/constants";
import { IApplicationItemRaw } from "../ApplicationsAbilitationsManagementStepOne/module/constants";
import { IEntitlementPaginatedRawData } from "../ApplicationsAbilitationsManagementStepThree/module/constants";

export const actionTypes = {
  FETCH_APPLICATIONS_MGMT_REQUEST: "FETCH_APPLICATIONS_MGMT_REQUEST",
  FETCH_APPLICATIONS_MGMT_REQUEST_SUCCESS:
    "FETCH_APPLICATIONS_MGMT_REQUEST_SUCCESS",
  FETCH_APPLICATIONS_MGMT_REQUEST_FAILURE:
    "FETCH_APPLICATIONS_MGMT_REQUEST_FAILURE",

  APPLICATION_MGMT_SELECTION: "APPLICATION_MGMT_SELECTION",

  FETCH_APPLICATION_PROPERTIES: "FETCH_APPLICATION_PROPERTIES",
  FETCH_APPLICATION_PROPERTIES_SUCCESS: "FETCH_APPLICATION_PROPERTIES_SUCCESS",
  FETCH_APPLICATION_PROPERTIES_FAILURE: "FETCH_APPLICATION_PROPERTIES_FAILURE",

  UPDATE_APPLICATION_PROPERTIES: "UPDATE_APPLICATION_PROPERTIES",
  UPDATE_APPLICATION_PROPERTIES_SUCCESS:
    "UPDATE_APPLICATION_PROPERTIES_SUCCESS",
  UPDATE_APPLICATION_PROPERTIES_FAILURE:
    "UPDATE_APPLICATION_PROPERTIES_FAILURE",

  FETCH_ENTITLEMENTS_MGMT_REQUEST: "FETCH_ENTITLEMENTS_MGMT_REQUEST",
  FETCH_ENTITLEMENTS_MGMT_REQUEST_SUCCESS:
    "FETCH_ENTITLEMENTS_MGMT_REQUEST_SUCCESS",
  FETCH_ENTITLEMENTS_MGMT_REQUEST_FAILURE:
    "FETCH_ENTITLEMENTS_MGMT_REQUEST_FAILURE",

  ENTITLEMENT_MGMT_SELECTION: "ENTITLEMENT_MGMT_SELECTION",

  FETCH_ENTITLEMENT_PROPERTIES: "FETCH_ENTITLEMENT_PROPERTIES",
  FETCH_ENTITLEMENT_PROPERTIES_SUCCESS: "FETCH_ENTITLEMENT_PROPERTIES_SUCCESS",
  FETCH_ENTITLEMENT_PROPERTIES_FAILURE: "FETCH_ENTITLEMENT_PROPERTIES_FAILURE",

  UPDATE_ENTITLEMENT_PROPERTIES: "UPDATE_ENTITLEMENT_PROPERTIES",
  UPDATE_ENTITLEMENT_PROPERTIES_SUCCESS:
    "UPDATE_ENTITLEMENT_PROPERTIES_SUCCESS",
  UPDATE_ENTITLEMENT_PROPERTIES_FAILURE:
    "UPDATE_ENTITLEMENT_PROPERTIES_FAILURE",

  FETCH_STEP_FIVE_ENTITLEMENTS_MGMT_REQUEST:
    "FETCH_STEP_FIVE_ENTITLEMENTS_MGMT_REQUEST",
  FETCH_STEP_FIVE_ENTITLEMENTS_MGMT_REQUEST_SUCCESS:
    "FETCH_STEP_FIVE_ENTITLEMENTS_MGMT_REQUEST_SUCCESS",
  FETCH_STEP_FIVE_ENTITLEMENTS_MGMT_REQUEST_FAILURE:
    "FETCH_STEP_FIVE_ENTITLEMENTS_MGMT_REQUEST_FAILURE",

  FETCH_CHAIN_ENTITLEMENTS_MGMT_REQUEST:
    "FETCH_CHAIN_ENTITLEMENTS_MGMT_REQUEST",
  FETCH_CHAIN_ENTITLEMENTS_MGMT_REQUEST_SUCCESS:
    "FETCH_CHAIN_ENTITLEMENTS_MGMT_REQUEST_SUCCESS",
  FETCH_CHAIN_ENTITLEMENTS_MGMT_REQUEST_FAILURE:
    "FETCH_CHAIN_ENTITLEMENTS_MGMT_REQUEST_FAILURE",

  UPDATE_CHAIN_ENTITLEMENT_REQUEST: "UPDATE_CHAIN_ENTITLEMENT_REQUEST",
  UPDATE_CHAIN_ENTITLEMENT_REQUEST_SUCCESS:
    "UPDATE_CHAIN_ENTITLEMENT_REQUEST_SUCCESS",
  UPDATE_CHAIN_ENTITLEMENT_REQUEST_FAILURE:
    "UPDATE_CHAIN_ENTITLEMENT_REQUEST_FAILURE",

  SET_CHAIN_ENTITLEMENT_TO_LIST: "SET_CHAIN_ENTITLEMENT_TO_LIST",
  ADD_CHAIN_ENTITLEMENT_TO_LIST: "ADD_CHAIN_ENTITLEMENT_TO_LIST",
  REMOVE_CHAIN_ENTITLEMENT_FROM_LIST: "REMOVE_CHAIN_ENTITLEMENT_FROM_LIST",

  GET_BAO: "GET_BAO",
  GET_BAO_SUCCESS: "GET_BAO_SUCCESS",
  GET_BAO_FAILURE: "GET_BAO_FAILURE",

  RESET_CHAIN_ENTITLEMENT_LIST: "RESET_CHAIN_ENTITLEMENT_LIST",
};

export const getBao = (payload: any | null) => ({
  type: actionTypes.GET_BAO,
  payload,
});
export const getBaoSuccess = (payload: any) => ({
  type: actionTypes.GET_BAO_SUCCESS,
  payload,
});
export const getBaoFailure = (err: Error) => ({
  type: actionTypes.GET_BAO_FAILURE,
  err,
});

export const getApplications = (payload: any) => ({
  type: actionTypes.FETCH_APPLICATIONS_MGMT_REQUEST,
  payload,
});
export const getApplicationsSuccess = (payload: any) => ({
  type: actionTypes.FETCH_APPLICATIONS_MGMT_REQUEST_SUCCESS,
  payload,
});
export const getApplicationsFailure = (payload: any) => ({
  type: actionTypes.FETCH_APPLICATIONS_MGMT_REQUEST_FAILURE,
  payload,
});

export const selectApplication = (payload: IApplicationItemRaw) => ({
  type: actionTypes.APPLICATION_MGMT_SELECTION,
  payload,
});

export const getApplicationProperties = (payload: any) => ({
  type: actionTypes.FETCH_APPLICATION_PROPERTIES,
  payload,
});
export const getApplicationPropertiesSuccess = (payload: any) => ({
  type: actionTypes.FETCH_APPLICATION_PROPERTIES_SUCCESS,
  payload,
});
export const getApplicationPropertiesFailure = (payload: any) => ({
  type: actionTypes.FETCH_APPLICATION_PROPERTIES_FAILURE,
  payload,
});

export const updateProperties = (payload: any) => ({
  type: actionTypes.UPDATE_APPLICATION_PROPERTIES,
  payload,
});
export const updatePropertiesSuccess = (payload: any) => ({
  type: actionTypes.UPDATE_APPLICATION_PROPERTIES_SUCCESS,
  payload,
});
export const updatePropertiesFailure = (payload: any) => ({
  type: actionTypes.UPDATE_APPLICATION_PROPERTIES_FAILURE,
  payload,
});

export const getEntitlements = (payload: any) => ({
  type: actionTypes.FETCH_ENTITLEMENTS_MGMT_REQUEST,
  payload,
});
export const getEntitlementsSuccess = (payload: any) => ({
  type: actionTypes.FETCH_ENTITLEMENTS_MGMT_REQUEST_SUCCESS,
  payload,
});
export const getEntitlementsFailure = (payload: any) => ({
  type: actionTypes.FETCH_ENTITLEMENTS_MGMT_REQUEST_FAILURE,
  payload,
});

export const selectEntitlement = (payload: IEntitlementPaginatedRawData) => ({
  type: actionTypes.ENTITLEMENT_MGMT_SELECTION,
  payload,
});

export const getEntitlementCustomProperties = (payload: any) => ({
  type: actionTypes.FETCH_ENTITLEMENT_PROPERTIES,
  payload,
});
export const getEntitlementCustomPropertiesSuccess = (payload: any) => ({
  type: actionTypes.FETCH_ENTITLEMENT_PROPERTIES_SUCCESS,
  payload,
});
export const getEntitlementCustomPropertiesFailure = (payload: any) => ({
  type: actionTypes.FETCH_ENTITLEMENT_PROPERTIES_FAILURE,
  payload,
});

export const updateEntitlementProperties = (payload: any) => ({
  type: actionTypes.UPDATE_ENTITLEMENT_PROPERTIES,
  payload,
});
export const updateEntitlementPropertiesSuccess = (payload: any) => ({
  type: actionTypes.UPDATE_ENTITLEMENT_PROPERTIES_SUCCESS,
  payload,
});
export const updateEntitlementPropertiesFailure = (payload: any) => ({
  type: actionTypes.UPDATE_ENTITLEMENT_PROPERTIES_FAILURE,
  payload,
});

export const getStepFiveEntitlements = (payload: any) => ({
  type: actionTypes.FETCH_STEP_FIVE_ENTITLEMENTS_MGMT_REQUEST,
  payload,
});
export const getStepFiveEntitlementsSuccess = (payload: any) => ({
  type: actionTypes.FETCH_STEP_FIVE_ENTITLEMENTS_MGMT_REQUEST_SUCCESS,
  payload,
});
export const getStepFiveEntitlementsFailure = (payload: any) => ({
  type: actionTypes.FETCH_STEP_FIVE_ENTITLEMENTS_MGMT_REQUEST_FAILURE,
  payload,
});

export const getChainEntitlements = (payload: {
  entitlementId: string;
  identitySystemId: string;
}) => ({
  type: actionTypes.FETCH_CHAIN_ENTITLEMENTS_MGMT_REQUEST,
  payload,
});
export const getChainEntitlementsSuccess = (payload: any) => ({
  type: actionTypes.FETCH_CHAIN_ENTITLEMENTS_MGMT_REQUEST_SUCCESS,
  payload,
});
export const getChainEntitlementsFailure = (payload: any) => ({
  type: actionTypes.FETCH_CHAIN_ENTITLEMENTS_MGMT_REQUEST_FAILURE,
  payload,
});

export const updateChainEntitlements = (
  payload: IChainEntitlementsUpdateBody
) => ({
  type: actionTypes.UPDATE_CHAIN_ENTITLEMENT_REQUEST,
  payload,
});
export const updateChainEntitlementsSuccess = (payload: any) => ({
  type: actionTypes.UPDATE_CHAIN_ENTITLEMENT_REQUEST_SUCCESS,
  payload,
});
export const updateChainEntitlementsFailure = (payload: any) => ({
  type: actionTypes.UPDATE_CHAIN_ENTITLEMENT_REQUEST_FAILURE,
  payload,
});

export const setChainEntitlementToList = (payload: any) => ({
  type: actionTypes.SET_CHAIN_ENTITLEMENT_TO_LIST,
  payload,
});
export const addChainEntitlementToList = (payload: any) => ({
  type: actionTypes.ADD_CHAIN_ENTITLEMENT_TO_LIST,
  payload,
});
export const removeChainEntitlementFromList = (payload: any) => ({
  type: actionTypes.REMOVE_CHAIN_ENTITLEMENT_FROM_LIST,
  payload,
});

export const resetChainEntitlementList = () => ({
  type: actionTypes.RESET_CHAIN_ENTITLEMENT_LIST,
});
